var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15048",
    fill: "none",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.611 11.596a1.212 1.212 0 011.18 1.209 1.187 1.187 0 01-1.18 1.18 1.212 1.212 0 01-1.209-1.18 1.237 1.237 0 011.209-1.209zM2 2.014h1.968l.562 1.18h8.88a.6.6 0 01.59.618.474.474 0 01-.085.281L11.78 7.972a1.183 1.183 0 01-1.04.618H6.271l-.534.984-.028.085a.133.133 0 00.141.141h6.938v1.209H5.597A1.212 1.212 0 014.417 9.8a1.276 1.276 0 01.141-.562l.815-1.49-2.164-4.553H2V2.014zm3.6 9.582a1.236 1.236 0 011.209 1.209 1.212 1.212 0 01-1.209 1.18 1.187 1.187 0 01-1.18-1.18 1.212 1.212 0 011.177-1.209z"
  })));
}
export default SvgBuyIcon;